module.exports = __webpack_public_path__ + "static/woman3-3x-de77a55890c17fc60f2af15f08b27cf2.png";